import { tv } from "tailwind-variants";

const STEPS = [
  {
    title: "Secure checkout",
    body: "Address and payment on the next screen. Nothing is charged until you confirm.",
  },
  {
    title: "Your first shipment",
    body: "Discreet packaging, free shipping.",
  },
  {
    title: "A check-in after your first week",
    body: "Your care team tunes the plan with you. Message or call anytime.",
  },
];

const careplanCartNextStepsVariants = tv({
  slots: {
    root: "rounded-xl bg-canvas px-[18px] py-4",
    heading: "text-lg font-semibold text-content",
    list: "mt-3.5 flex flex-col gap-4",
    step: "relative flex gap-3",
    /* Runs from the bottom of this step's circle to the top of the next one, across the gap. */
    connector: "absolute top-6 -bottom-4 left-3 w-px bg-line",
    circle: "flex size-6 shrink-0 items-center justify-center rounded-full text-base font-semibold",
    title: "text-base leading-snug font-semibold text-content",
    body: "text-base leading-normal text-content-secondary",
  },
  variants: {
    current: {
      true: {
        circle: "bg-surface-inverted text-content-on-inverted",
      },
      false: {
        circle: "border border-line bg-surface text-content",
      },
    },
  },
});

const { body, circle, connector, heading, list, root, step, title } =
  careplanCartNextStepsVariants();

type CareplanCartNextStepsProps = {
  className?: string;
};

export const CareplanCartNextSteps = ({ className }: CareplanCartNextStepsProps) => {
  return (
    <section aria-labelledby="cart-next-steps-heading" className={root({ className })}>
      <h3 className={heading()} id="cart-next-steps-heading">
        What happens next
      </h3>
      <ol className={list()}>
        {STEPS.map((item, index) => {
          const isLast = index === STEPS.length - 1;

          return (
            <li className={step()} key={item.title}>
              {isLast ? null : <span aria-hidden="true" className={connector()} />}
              <span aria-hidden="true" className={circle({ current: index === 0 })}>
                {index + 1}
              </span>
              <div className="flex flex-col">
                <p className={title()}>{item.title}</p>
                <p className={body()}>{item.body}</p>
              </div>
            </li>
          );
        })}
      </ol>
    </section>
  );
};
